<template>
  <div class="why" id="why">
    <div class="why__top">
      <div class="container">
        <div class="why__top-wrapper">
          <h2>Why You Should Choose Us</h2>
          <p>we don’t just provide IT services; we partner with you to enhance your business operations, safeguard your data, and propel your growth</p>
        </div>
      </div>
    </div>
    <div class="why__main">
      <div class="container">
        <div class="why__main-wrapper">
          <div class="why__main-row">
            <div class="why__main-item">
              <div>
                <img src="@images/whyItemImage1.png" alt="">
              </div>
              <h6>Expertise</h6>
              <p>Our teams Are professionals with extensive industry experience</p>
            </div>
            <div class="why__main-item">
              <div>
                <img src="@images/whyItemImage2.png" alt="">
              </div>
              <h6>Support</h6>
              <p>Our dedicated support team is available around the clock</p>
            </div>
          </div>
          <div class="why__main-row">
            <div class="why__main-item">
              <div>
                <img src="@images/whyItemImage3.png" alt="">
              </div>
              <h6>Tailored Solutions</h6>
              <p>We customize our services to meet your specific business needs</p>
            </div>
            <div class="why__main-item">
              <div>
                <img src="@images/whyItemImage4.png" alt="">
              </div>
              <h6>Partnership Focus</h6>
              <p>We believe in building long-lasting relationships and collaboration</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.why {
  &__top {
    background-color: $white;
    box-shadow: 0 4px 10.8px 0 rgba(0, 0, 0, 0.25);
    padding-block: 35px 40px;

    &-wrapper {
      display: flex;
      flex-direction: column;
      gap: 30px;

      & h2 {
        color: #272343;
        font-size: 28px;
        font-weight: 900;
        text-transform: capitalize;
      }

      & p {
        color: #636270;
        font-size: 16px;
        font-weight: 400;
        text-transform: capitalize;
      }
    }
  }

  &__main {
    background-image: url(@images/whyBg.png);
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
    position: relative;

    //&:after {
    //  content: "";
    //  position: absolute;
    //  inset: 0;
    //  width: 100%;
    //  height: 100%;
    //  background-color: rgba(255, 255, 255, 0.29);
    //  backdrop-filter: blur(11.050000190734863px);
    //}

    &-wrapper {
      position: relative;
      z-index: 1;
      padding-block: 85px 200px;
      display: flex;
      flex-direction: column;
      gap: 60px;
    }

    &-row {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 100px;

      &:last-child {
        margin-left: 150px;
      }
    }

    &-item {
      border-radius: 26px;
      border: 1px solid #E0E0E0;
      background-color: $white;
      box-shadow: 0 4px 31.1px 0 rgba(0, 0, 0, 0.20);
      width: 400px;
      height: 150px;
      padding-top: 26px;
      padding-left: 50px;
      position: relative;

      & div {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -65px;
        width: 100px;
        aspect-ratio: 1;
        background: linear-gradient(210deg, #EAF5FF 7.73%, #8AB8E5 92.27%);
        display: grid;
        place-items: center;
        border-radius: 50%;

        & img {
          width: 75px;
        }
      }

      & h6 {
        color: #272343;
        font-size: 26px;
        font-weight: 700;
        text-transform: capitalize;
      }

      & p {
        margin-top: 18px;
        color: #636270;
        font-size: 16px;
        font-weight: 400;
        text-transform: capitalize;
      }
    }
  }
}

@media (max-width: 1400px) {
  .why {
    &__main {
      &-row {
        gap: 150px;
      }

      &-item {
        width: 330px;
        height: 145px;
        padding-left: 50px;

        & div {
          width: 100px;

          & img {
            width: 75px;
          }
        }

        & h6 {
          font-size: 24px;
        }

        & p {
          font-size: 14px;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .why {
    &__main {
      &-row {
        gap: 100px;
        justify-content: center;

        &:last-child {
          margin-left: 0;
        }
      }
    }
  }
}

@media (max-width: 700px) {
  .why {
    &__main {
      &-row {
        flex-direction: column;
        gap: 40px;
      }
    }
  }
}
</style>